import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "../contaFinanceira/pages/cadastrar";
import PagamentosPage from "../contaFinanceira/pages/pagamentos";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
  pagamentos: PagamentosPage,
};

const LancamentoBancarioPageController = () => {
  //estados globais
  const lancamentoBancarioState = useAppSelector((state) => state.lancamentoBancario);

  const Page = pages[lancamentoBancarioState.page];

  return <Page key={lancamentoBancarioState.page} />;
};

export default LancamentoBancarioPageController;
